import * as angular from 'angular';
import { IUtilities } from '../../typings/services';

/**
 * Simple wrapper for md-select, to help defer compilation of a cl-input-container until all elements are ready to be compiled.
 */
export class ClSelectDirective implements angular.IDirective {
    public static $name: string = 'clSelect';

    /** Required for 'require' object syntax to function correctly */
    public bindToController: boolean = true;

    public controller = ClSelectController;
    public restrict: string = 'E';

    /** We need to be able to reference both the parent input container & our own controller */
    public require: any = {
        clInputContainerController: '^clInputContainer',
        clSelectController: 'clSelect'
    };

    public link = (scope: any, element: angular.IAugmentedJQuery, attrs: angular.IAttributes, controllers: any) => {
        /* Generate a new element & copy all attributes over to it */
        const select = angular.element('<md-select></md-select>');
        this.utilities.copyAllAttributes(select, attrs);

        /* Add an aria-label if we didn't already have one */
        if (!select.attr('aria-label')) {
            select.attr('aria-label', select.attr('name'));
        }

        /* Add the options that were added in the link phase of child cl-options directives */
        select.append(controllers.clSelectController.options);

        /* Attach the completed, uncompiled select box back to the input-container's controller */
        controllers.clInputContainerController.input = select;

        /* Remove this element as it is no longer needed */
        element.remove();

        /* $compile takes place in cl-input-container */
    }

    constructor(
        private utilities: IUtilities
    ) {
    }

    public static Factory() {
        const directive = (utilities) => {
            return new ClSelectDirective(utilities);
        };

        directive['$inject'] = ['utilities'];

        return directive;
    }
}

// tslint:disable-next-line:max-classes-per-file
export class ClSelectController implements angular.IController {
    public options: angular.IAugmentedJQuery;
}
